import { FunctionComponent } from 'react'
import { useStyles } from './styles'
import { Illustration } from '@conexasaude/iconography/illustrations'
import { Button, Text } from '@conexasaude/conexa-hero'
import { ApptConfirmStatusProps } from './types'

const AppointmentConfirmationStatus: FunctionComponent<
  ApptConfirmStatusProps
> = ({ buttonText, onClick, title, description, ilustration }) => {
  const styles = useStyles()
  return (
    <div css={styles.containerBox}>
      <Illustration name={ilustration} />
      <Text renderAs="h1" variant="headingLarge" textAlign="center">
        {title}
      </Text>
      <Text renderAs="h6" variant="paragraphLarge" textAlign="center">
        <p
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        ></p>
      </Text>
      <Button onClick={onClick} css={styles.submitButton}>
        {buttonText}
      </Button>
    </div>
  )
}
export default AppointmentConfirmationStatus
